export default __webpack_public_path__ + "img/a0bbc5643432ae5ebc4ad048d9c9ce8c.svg";